module.exports = __webpack_public_path__ + "static/media/status_verified.0f3b5973.svg";